export enum PdfSettingsSizeEnum {
  NONE = 'NONE',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  USER_DEFINED = 'USER_DEFINED',
}
